document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('[data-modal]');
    const close = document.querySelector('.modal-close');
    if (btn && close) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          document.body.classList.remove('modal-open');
        }
      });
      btn.addEventListener('click', (e) => {
          document.body.classList.add('modal-open');
      });
      close.addEventListener('click', (e) => {
        document.body.classList.remove('modal-open');
      });
    }
});